<template>
  <div class="row-bg">
    <el-tabs v-model="activeName" @tab-click="tabsChange">
      <el-tab-pane label="内部动态" name="inner">
        <el-row type="flex" :gutter="26">
          <el-col v-for="(item,index) of dataSet.list" :key="'inner-'+index">
            <div class="images">
              <img :src="item.image" alt />
              <div class="bgbox"></div>
              <span @click="toDetail(item)">查看</span>
            </div>
            <div class="box-dynamic">
              <div class="text">
                <h3>{{item.title}}</h3>
                <p>{{item.subtitle}}</p>
              </div>
              <div class="detail" @click="toDetail(item)">
                查看详情
                <img src="../../assets/home/route2.png" />
              </div>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="外部动态" name="outer">
        <el-row type="flex" :gutter="26">
          <el-col v-for="(item,index) of dataSet.list" :key="'outer-'+index">
            <div class="images">
              <img :src="item.image" alt />
              <div class="bgbox"></div>
              <span @click="toDetail(item)">查看</span>
            </div>
            <div class="box-dynamic">
              <div class="text">
                <h3>{{item.title}}</h3>
                <p>{{item.subtitle}}</p>
              </div>
              <div class="detail" @click="toDetail(item)">
                查看详情
                <img src="../../assets/home/route2.png" />
              </div>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="dataSet.total"
      :page-size="dataSet.per_page"
      :current-page="dataSet.current_page"
      @current-change="getList"
      hide-on-single-page
    ></el-pagination>
  </div>
</template>
<script>
const dynamicListUri = "website/index/news/get/all";

export default {
  model: {
    prop: "show",
    event: "change"
  },
  props: {
    show: Boolean
  },
  data() {
    return {
      activeName: "",
      showType: undefined,
      dataSet: {
        list: [],
        total: 0,
        current_page: 1,
        per_page: 6
      }
    };
  },
  methods: {
    toDetail(item) {
      this.$cache.set("showDynamic", item);
      this.$cache.set("rootin", '');
      this.$emit("change", true);
    },
    tabsChange($event) {
      this.$router.replace(`/news/${$event.name}`);
    },
    // 获取动态
    getList(page) {
      this.$api
        .get(dynamicListUri, {
          in_out: this.showType,
          page: page,
          pageSize: this.dataSet.per_page
        })
        .then(res => {
          res.per_page = parseInt(res.per_page);
          this.dataSet = res;
        });
    }
  },
  mounted() {
    this.activeName = this.$route.params.tag;
  },
  watch: {
    $route(to, from) {
      // console.log(to,from)
      this.activeName = to.params.tag;
    },
    activeName(now) {
      if (this.activeName == "inner") {
        this.showType = 1;
        this.getList(1);
      }
      if (this.activeName == "outer") {
        this.showType = 2;
        this.getList(1);
      }
    }
  }
};
</script>
<style lang="less">
.row-bg {
  width: 1200px;
  margin: 0 auto;
  padding: 48px;
  position: relative;
  background: #fff;
  .el-tabs__header {
    margin: 0;
    .el-tabs__nav-wrap::after {
      height: 0;
    }
    .el-tabs__item {
      font-size: 30px;
      height: 60px;
      opacity: 0.2;
      font-weight: 500;
      color: #333;
    }
    .is-active {
      opacity: 1;
    }
  }
  .el-tabs__content {
    .el-row {
      flex-wrap: wrap;
      .el-col {
        width: 375px;
        margin-top: 36px;
        .images {
          overflow: hidden;
          position: relative;
          height: 196px;
          img {
            width: 100%;
            height: 100%;
            transform: scale(1, 1);
            transition: all 0.5s ease;
          }
          span {
            color: #fff;
            position: absolute;
            width: 350px;
            height: 196px;
            top: 0;
            left: 0;
            font-size: 16px;
            text-align: center;
            line-height: 196px;
            z-index: 999;
            transition: all 0.5s ease;
            cursor: pointer;
          }
        }
        .images:hover {
          img {
            transform: scale(1.1, 1.1);
            transition: all 0.5s ease;
          }
          .bgbox {
            position: absolute;
            width: 350px;
            height: 196px;
            top: 0;
            left: 0;
            z-index: 99;
            background: #000;
            opacity: 0.4;
          }
          span {
            display: block;
            transition: all 0.5s ease;
          }
        }
        .box-dynamic {
          border: 1px solid #eeeeee;
          border-radius: 0 0 2px 2px;
          padding-left: 16px;
          display: flex;
          align-items: center;

          .text {
            flex: 1;
            padding-right: 10px;

            h3 {
              font-size: 18px;
              font-weight: 500;
              color: #333;
              line-height: 27px;
              margin-top: 14px;
              overflow: hidden;
              display: -webkit-box; //将元素设为盒子伸缩模型显示
              -webkit-box-orient: vertical; //伸缩方向设为垂直方向
              -webkit-line-clamp: 1; //超出1行隐藏，并显示省略号
            }
            p {
              font-size: 15px;
              color: #999999;
              line-height: 15px;
              margin-top: 6px;
              margin-bottom: 14px;
              overflow: hidden;
              display: -webkit-box; //将元素设为盒子伸缩模型显示
              -webkit-box-orient: vertical; //伸缩方向设为垂直方向
              -webkit-line-clamp: 1; //超出1行隐藏，并显示省略号
            }
          }

          .detail {
            width: 95px;
            font-size: 16px;
            font-weight: 500;
            line-height: 24px;
            cursor: pointer;

            img {
              width: 17px;
              height: 3px;
              vertical-align: middle;
            }
          }
        }
      }
    }
  }
  .el-pagination {
    margin-top: 15px;
    text-align: right;
  }
}
</style>
